module.exports = __webpack_public_path__ + "img/苍南县教师发展中心.cbbefaf3.png";